import { addHours, subHours, subMonths, subYears } from 'date-fns';

export type DateRangePreset = {
  startDate: Date;
  endDate: Date;
};

export const getLastMonthRange = (now: Date): DateRangePreset => ({
  startDate: addHours(subMonths(now, 1), 1),
  endDate: subHours(now, 1),
});

export const getLastYearRange = (now: Date): DateRangePreset => ({
  startDate: addHours(subYears(now, 1), 1),
  endDate: subHours(now, 1),
});
